module.exports = __webpack_public_path__ + "static/gift_icon.12f6956c.jpg";